export default {"src":"/_next/static/media/collect.e9fea0b7.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};